.<template>
  <div class="media-controls">
    <div class="media-buttons">
      <a class="card-header-icon" @click="incrementAudio(-10)">
        <b-icon icon="rewind-10" />
      </a>
      <a class="card-header-icon" @click="toggleAudio()">
        <b-icon
          :icon="playState ? 'pause-circle-outline' : 'play-circle-outline'"
          size="is-medium"
        />
      </a>
      <a class="card-header-icon" @click="incrementAudio(10)">
        <b-icon icon="fast-forward-10" />
      </a>
    </div>
    <b-field class="slider">
      <b-slider
        size="is-small"
        type="is-danger"
        v-model="timeModel"
        :step="0.1"
        :custom-formatter="val => val.toFixed(0) + '%'"
        lazy
        rounded
      >
      </b-slider>
      <p class="content">
        {{ currTime }}
      </p>
    </b-field>
  </div>
</template>

<script>
export default {
  name: "AudioBar",
  props: {
    path: {
      type: String
    },
    startTime: {
      type: Number
    }
  },
  data() {
    return {
      timeRepresentative: 0,
      currTime: "0:00",
      audio: null
    };
  },
  beforeDestroy() {
    this.$emit("timeRepresentative", this.audio.currentTime);
  },
  created() {
    // Set audio to where it was last stopped at
    const audioData = require(`@/assets/sites/${this.selected}/narration/${this.path}`);
    let newAudio = new Audio(audioData);
    newAudio.currentTime = this.startTime;
    this.audio = newAudio;
    newAudio.addEventListener("loadeddata", () => {
      this.timeRepresentative = 100 * (this.startTime / newAudio.duration);
    });

    // Update the bar timestamp
    let time = this.audio.currentTime.toString();
    let minutes = Math.floor(time / 60);
    let seconds = Math.floor(time % 60);
    seconds = seconds > 9 ? seconds : "0" + seconds;
    this.currTime = minutes + ":" + seconds;
  },
  computed: {
    currentAudio() {
      return this.$store.state.currentAudio;
    },
    selected() {
      return this.$store.state.selected;
    },
    playState() {
      return this.$store.state.audioPlayState;
    },
    timeModel: {
      get: function() {
        return this.timeRepresentative;
      },
      set: function(value) {
        // This restricts it to user input greater than 1,
        // preventing updates on scrub activation
        if (this.audio && Math.abs(value - this.timeRepresentative) > 1) {
          this.audio.currentTime = this.audio.duration * (value / 100);
        }
      }
    }
  },
  watch: {
    timeRepresentative: function() {
      let time = this.audio.currentTime.toString();
      let minutes = Math.floor(time / 60);
      let seconds = Math.floor(time % 60);
      seconds = seconds > 9 ? seconds : "0" + seconds;
      this.currTime = minutes + ":" + seconds;
    }
  },
  methods: {
    toggleAudio() {
      this.$store.commit("setAudioPlayState", !this.playState);
      if (this.playState) {
        this.audio.play();
        this.$store.commit("setAudioObject", this.audio);
        this.audio.addEventListener("ended", () => {
          this.$store.commit("setAudioObject", null);
          this.$store.commit("setAudioPlayState", false);
        });
        this.audio.addEventListener("timeupdate", () => {
          this.timeRepresentative =
            100 * (this.audio.currentTime / this.audio.duration);
        });
      } else {
        this.currentAudio.pause();
      }
    },
    incrementAudio(value) {
      this.audio.currentTime += value;
    }
  }
};
</script>

<style lang="scss" scoped>
.card-header-icon {
  color: $white;
}

.media-controls {
  background-color: $maroon;
}

.media-buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.slider {
  padding: 0 10% 1%;
  p {
    padding-top: 2%;
    padding-left: 2%;
  }
}
</style>
